module.exports = __webpack_public_path__ + "static/media/mas.b6e435d8.png";